import styled from 'styled-components';

export const ConferenceContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
  height: auto;
  min-height: 400px;
  max-height: calc(100vh - 48px);
  background: #111827;
  color: white;
  max-width: 1200px;
  margin: 24px auto;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgb(0 0 0 / 0.2);
  backdrop-filter: blur(8px);
  position: relative;

  /* Murphy warning animation */
  @keyframes pulse {
    0% { 
      transform: scale(1); 
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7); 
    }
    50% { 
      transform: scale(1.02); 
      box-shadow: 0 0 0 10px rgba(255, 152, 0, 0.3); 
    }
    100% { 
      transform: scale(1); 
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0); 
    }
  }
`;

export const MainPresenterView = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  background: linear-gradient(145deg, #1e2837 0%, #111827 100%);
  border-radius: 12px;
  overflow: hidden;
  height: 460px;
  aspect-ratio: 16/9;
  box-shadow: 0 8px 16px rgb(0 0 0 / 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: black;
    position: absolute;
    top: 0;
    left: 0;
  }

  .video-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #2d2e30;
    color: #fff;
    font-size: 1.2rem;
    position: relative;

    img {
      width: 120px;
      opacity: 0.5;
      margin-bottom: 16px;
    }

    .placeholder-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .status-overlay {
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;

      .murphy-status {
        display: flex;
        align-items: center;
        gap: 12px;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(8px);
        padding: 12px 20px;
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.9rem;
        transition: all 0.2s ease;
        
        .loading-icon {
          color: #60A5FA;
          font-size: 1.1rem;
        }

        .status-content {
          .status-message {
            a {
              color: #60A5FA;
              text-decoration: none;
              font-weight: 500;
              
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7); }
          50% { transform: scale(1.02); box-shadow: 0 0 0 10px rgba(255, 152, 0, 0.3); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 152, 0, 0); }
        }
        
        animation: fadeIn 0.3s ease;
    }
  }
`;

export const SidePanel = styled.div`
  width: 200px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;

  .duration {
    position: fixed;
    bottom: 40px;
    right: 40px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
    padding: 8px 16px;
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: 44px;
  border: none;
  padding: 0;

  .duration {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
    padding: 8px 0;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.2);
  }

  .controls {
    display: flex;
    justify-content: center;
    gap: 4px;
  }
`;

export const ParticipantsContainer = styled.div`
  background: linear-gradient(145deg, #1e2837 0%, #111827 100%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  box-shadow: 0 8px 16px rgb(0 0 0 / 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  h3 {
    margin: 0;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export const ParticipantCard = styled.div.withConfig({
  shouldComponentUpdate: true,
  // Tell styled-components which props are styling only
  shouldForwardProp: (prop) => !['currentQuestion', 'backgroundColor', 'hasQuestion'].includes(prop),
})`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;

  @keyframes borderBlink {
    0% { border-color: rgba(255, 215, 0, 0.3); }
    50% { border-color: rgba(255, 215, 0, 1); }
    100% { border-color: rgba(255, 215, 0, 0.3); }
  }

  ${props => props.hasQuestion && `
    border-color: #ffd700;
    background: rgba(255, 215, 0, 0.1);
    animation: borderBlink 2s ease-in-out infinite;
  `}

  &:hover {
    background: ${props => props.hasQuestion ? 'rgba(255, 215, 0, 0.15)' : 'rgba(0, 0, 0, 0.3)'};
    transform: translateY(-1px);
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: ${props => props.backgroundColor};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    color: white;
    font-size: 0.9rem;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.15);
    transition: all 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(8px);
    
    &:hover {
      transform: scale(1.05);
    }
  }

  .info {
    flex: 1;
    min-width: 0;
    
    .name {
      font-weight: 500;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.9rem;
    }
  }
`;
